import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, "助教管理", -1)
const _hoisted_2 = { class: "page__header" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增助教 ")
const _hoisted_4 = { class: "page__body" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("編輯")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("刪除助教")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 更多 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("解除綁定")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 更多 ")
const _hoisted_14 = { style: { fontSize: '1rem' } }
const _hoisted_15 = {
  key: 1,
  align: "center",
  style: { padding: '40px 0' }
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_CreateMemberModal = _resolveComponent("CreateMemberModal")!
  const _component_EditMemberModal = _resolveComponent("EditMemberModal")!
  const _component_MemberInfoDrawer = _resolveComponent("MemberInfoDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout_header, { class: "layout-header" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  class: "header-menu-btn",
                  type: "link",
                  shape: "circle",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.appStore.collapsed=!_ctx.appStore.collapsed))
                }, {
                  icon: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "mdi mdi-menu",
                      style: _normalizeStyle({ color: '#212121', fontSize: '1.5rem' })
                    }, null, 4)
                  ]),
                  _: 1
                }),
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_layout_content, { class: "layout-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_card, {
          class: "app-channel-assistants-page",
          bordered: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    lg: 12,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: _normalizeClass({ 'mb-2': _ctx.device.mobile }),
                        type: "primary",
                        onClick: _ctx.openCreateMemberModal
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_PlusOutlined)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["class", "onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    lg: 7,
                    offset: _ctx.device.mobile ? 0 : 5,
                    xs: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_search, {
                        value: _ctx.searchValue,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchValue) = $event)),
                        placeholder: "輸入 會員編號 / 姓名 / 手機號碼 搜尋",
                        "enter-button": "",
                        allowClear: "",
                        onSearch: _ctx.searchAssistantsData
                      }, null, 8, ["value", "onSearch"])
                    ]),
                    _: 1
                  }, 8, ["offset"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!_ctx.device.mobile)
                      ? (_openBlock(), _createBlock(_component_a_table, {
                          key: 0,
                          columns: _ctx.columns,
                          "data-source": _ctx.assistantsData,
                          rowKey: "uid",
                          bordered: "",
                          scroll: { x: 'max-content' }
                        }, {
                          bodyCell: _withCtx(({ column, text, record }) => [
                            (column.key === 'gender')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (record.gender == 'male')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "先生"))
                                    : (record.gender == 'female')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "女士"))
                                      : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                            (column.key === 'birthdate')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (record.birthdate)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(record.birthdate) + " (" + _toDisplayString(_ctx.calculateAge(record.birthdate)) + "歲) ", 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                            (column.key === 'action')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createVNode(_component_a_button, {
                                    class: "mr-2",
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.openMemberInfoDrawer(record.uid))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_7
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_a_button, {
                                    class: "mr-2",
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.openEditMemberModal(record))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_8
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_a_dropdown, null, {
                                    overlay: _withCtx(() => [
                                      _createVNode(_component_a_menu, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_popconfirm, {
                                            title: `確認刪除助教 ${record.name}？`,
                                            "ok-text": "確定",
                                            "cancel-text": "取消",
                                            danger: "",
                                            onConfirm: ($event: any) => (_ctx.deleteOne(record.uid)),
                                            onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.message.info('取消刪除助教動作')))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_menu_item, {
                                                key: "3",
                                                danger: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_9
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["title", "onConfirm"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, { size: "small" }, {
                                        default: _withCtx(() => [
                                          _hoisted_10,
                                          _createVNode(_component_DownOutlined)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source"]))
                      : (_openBlock(), _createBlock(_component_a_list, {
                          key: 1,
                          "item-layout": "horizontal",
                          "data-source": _ctx.assistantsData
                        }, {
                          renderItem: _withCtx(({ item }) => [
                            _createVNode(_component_a_list_item, null, {
                              actions: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  class: "mr-2",
                                  type: "text",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.openMemberInfoDrawer(item.uid))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_11
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_a_dropdown, null, {
                                  overlay: _withCtx(() => [
                                    _createVNode(_component_a_menu, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_menu_item, {
                                          disabled: !item.line_id,
                                          onClick: ($event: any) => (_ctx.unbind(item.uid, item.line_id))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_12
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      size: "small",
                                      type: "text"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_13,
                                        _createVNode(_component_DownOutlined)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_skeleton, {
                                  avatar: "",
                                  title: false,
                                  loading: !!item.loading,
                                  active: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_list_item_meta, {
                                      description: item.member_id
                                    }, {
                                      title: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1)
                                      ]),
                                      avatar: _withCtx(() => [
                                        _createVNode(_component_a_avatar, {
                                          src: item.avatar!=null ? item.avatar.uri : require('@/assets/icons/avatar.png')
                                        }, null, 8, ["src"])
                                      ]),
                                      _: 2
                                    }, 1032, ["description"])
                                  ]),
                                  _: 2
                                }, 1032, ["loading"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }, 8, ["data-source"]))
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_a_spin, {
                      tip: "載入資料中...",
                      style: { margin: '0 auto' }
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CreateMemberModal, {
      visible: _ctx.createMemberModal.visible,
      role: _ctx.createMemberModal.role,
      onConfirm: _ctx.handleCreateMemberModalConfirm,
      onCancel: _ctx.handleCreateMemberModalCancel
    }, null, 8, ["visible", "role", "onConfirm", "onCancel"]),
    _createVNode(_component_EditMemberModal, {
      visible: _ctx.editMemberModal.visible,
      role: _ctx.editMemberModal.role,
      data: _ctx.editMemberModal.data,
      onConfirm: _ctx.handleEditMemberModalConfirm,
      onCancel: _ctx.handleEditMemberModalCancel
    }, null, 8, ["visible", "role", "data", "onConfirm", "onCancel"]),
    _createVNode(_component_MemberInfoDrawer, {
      uid: _ctx.memberInfoDrawer.uid,
      visible: _ctx.memberInfoDrawer.visible,
      onClose: _ctx.handleMemberInfoDrawerClose
    }, null, 8, ["uid", "visible", "onClose"])
  ], 64))
}